import Swiper from "swiper";
import {
    Navigation,
    A11y,
    Keyboard,
    Pagination,
    EffectFade,
    Thumbs,
} from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import "swiper/css/a11y";
import "swiper/css/effect-fade";

const syncGalleryDescription = (swiper, descriptionElement) => {
    if (!descriptionElement) {
        return;
    }

    const currentDescription = descriptionElement.querySelector(
        ".image-gallery-description-current",
    );

    if (!currentDescription) {
        return;
    }

    const activeSlide = swiper.slides?.[swiper.activeIndex];
    const content = activeSlide?.dataset.galleryDescription?.trim() ?? "";

    currentDescription.textContent = content;
    descriptionElement.hidden = content === "";
};

const galleryDescription = document.querySelector(".image-gallery-description");

const thumbSwiper = new Swiper(".image-gallery-thumbs", {
    spaceBetween: 10,
    slidesPerView: 3,
    freeMode: true,
    watchSlidesProgress: true,
});

const imageGallery = new Swiper(".image-gallery", {
    modules: [Navigation, A11y, Keyboard, Thumbs],
    speed: 500,
    spaceBetween: 10,
    loop: true,
    navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
    },
    keyboard: {
        enabled: true,
    },
    on: {
        init(swiper) {
            syncGalleryDescription(swiper, galleryDescription);
        },
        slideChange(swiper) {
            syncGalleryDescription(swiper, galleryDescription);
        },
        realIndexChange(swiper) {
            syncGalleryDescription(swiper, galleryDescription);
        },
    },
    a11y: {
        prevSlideMessage: "Vorheriges Element",
        nextSlideMessage: "Nächstes Element",
        containerRoleDescriptionMessage: "Karussell-Container",
        firstSlideMessage: "Dies ist das erste Bildelement des Karussels",
        lastSlideMessage: "Dies ist das letzte Bildelement des Karussels",
        itemRoleDescriptionMessage: "Karussel-Element",
    },
    thumbs: {
        swiper: thumbSwiper,
    },
    // breakpoints: {
    //     // when window width is >= 320px
    //     320: {
    //         slidesPerView: 1,
    //         spaceBetween: 20,
    //     },
    //     // when window width is >= 480px
    //     480: {
    //         slidesPerView: 2,
    //         spaceBetween: 30,
    //     },
    //     // when window width is >= 640px
    //     820: {
    //         slidesPerView: 3,
    //         spaceBetween: 60,
    //     },
    // },
});

const heroSliderMediaQuery = window.matchMedia("(min-width: 1024px)");

let heroslider;

const forEachHeroSlider = (callback) => {
    if (Array.isArray(heroslider)) {
        heroslider.forEach(callback);
        return;
    }

    if (heroslider) {
        callback(heroslider);
    }
};

const getActiveHeroSlider = () => {
    if (Array.isArray(heroslider)) {
        return heroslider.find((swiper) => !swiper.destroyed);
    }

    return heroslider && !heroslider.destroyed ? heroslider : null;
};

const initHeroSlider = () => {
    const activeSlideIndex = getActiveHeroSlider()?.realIndex ?? 0;

    forEachHeroSlider((swiper) => {
        if (!swiper.destroyed) {
            swiper.destroy(true, true);
        }
    });

    heroslider = new Swiper(".hero-slider", {
        modules: [Navigation, A11y, Keyboard, Pagination, EffectFade],
        autoHeight: !heroSliderMediaQuery.matches,
        initialSlide: activeSlideIndex,
        spaceBetween: 0,
        effect: "fade",
        fadeEffect: {
            crossFade: true,
        },
        navigation: {
            nextEl: ".swiper-button-next",
            prevEl: ".swiper-button-prev",
        },
        pagination: {
            el: ".swiper-pagination",
            clickable: true,
        },
        keyboard: {
            enabled: true,
        },
    });
};

initHeroSlider();

if (heroSliderMediaQuery.addEventListener) {
    heroSliderMediaQuery.addEventListener("change", initHeroSlider);
} else {
    heroSliderMediaQuery.addListener(initHeroSlider);
}

export { imageGallery, heroslider };
